import { FlashbarProps } from "@amzn/awsui-components-react";
import * as mammoth from "mammoth";

export class FileProcessingUtil {
    static validateFile(file: File): { isValid: boolean; error?: string } {
        if (file.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            return {
                isValid: false,
                error: "Only .docx files are supported"
            };
        }
        return { isValid: true };
    }

    static async extractTextFromDocx(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                try {
                    if (!event.target || !event.target.result) {
                        reject(new Error("Failed to read file"));
                        return;
                    }
                    const arrayBuffer = event.target.result as ArrayBuffer;

                    try {
                        const result = await mammoth.extractRawText({ arrayBuffer });
                        resolve(result.value);
                    } catch (mammothError) {
                        reject(new Error(`Error extracting text: ${mammothError.message}`));
                    }
                } catch (error) {
                    reject(error);
                }
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsArrayBuffer(file);
        });
    }

    static handleFileValidationError(
        error: string,
        onFlashbarUpdated?: (flashbarProps: Pick<FlashbarProps, "items"> | undefined) => void
    ): void {
        onFlashbarUpdated?.({
            items: [{
                type: "error",
                content: error,
                dismissible: true,
                onDismiss: () => onFlashbarUpdated?.(undefined)
            }]
        });
    }

    static handleFileProcessingError(
        error: Error,
        onFlashbarUpdated?: (flashbarProps: Pick<FlashbarProps, "items"> | undefined) => void
    ): void {
        onFlashbarUpdated?.({
            items: [{
                type: "error",
                content: `Failed to extract text from docx file: ${error.message || "Unknown error"}`,
                dismissible: true,
                onDismiss: () => onFlashbarUpdated?.(undefined)
            }]
        });
    }
}
